import { FunctionComponent } from 'react';

import styled, { keyframes } from 'styled-components';

import media from 'chime-ui/system/media';

export const iconsPath =
  process.env.NODE_ENV === 'development' ? '/icons/' : '/pay/icons/';

export const MoneyBox: FunctionComponent = () => (
  <MoneyBoxStyling
    src={`${iconsPath}successIllustration.svg`}
    alt={`Money box illustration`}
  />
);

export const CaratIcon: FunctionComponent = () => (
  <img alt="Carat Pointing Up" src={`${iconsPath}carat.svg`} />
);

export const MoneyStackIcon: FunctionComponent = () => (
  <img alt="Small Stack of Money" src={`${iconsPath}moneyStack.svg`} />
);

export const CalendarIcon: FunctionComponent = () => (
  <img alt="Calendar with Pink Cricle" src={`${iconsPath}calendar.svg`} />
);

export const PadLockIcon: FunctionComponent = () => (
  <ValuePropIcon alt="Pad Lock" src={`${iconsPath}padLock.png`} />
);

export const ScissorFeesIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Scissors cutting the word fees"
    src={`${iconsPath}scissorsFees.png`}
  />
);

export const ScissorFeesLargeIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Scissors cutting the word fees"
    src={`${iconsPath}scissorsFeesLarge.png`}
  />
);

export const UsingBankingAppIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Hand Using Banking App on Phone"
    src={`${iconsPath}handHoldingPhone.png`}
  />
);

export const PadLockLargeIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Scissors cutting the word fees"
    src={`${iconsPath}padLockLarge.png`}
  />
);

export const ThreePeopleIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Three people and a baby"
    src={`${iconsPath}threePeople.png`}
  />
);

export const HeadSetDudeIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Person with a Headset"
    src={`${iconsPath}headSetDude.png`}
  />
);

export const MoneyPhoneIcon: FunctionComponent = () => (
  <ValuePropIcon
    alt="Money Hovering Over a Cell Phone"
    src={`${iconsPath}moneyPhone.png`}
  />
);

export const MicroBlinkIcon: FunctionComponent = () => (
  <img alt={'Powered by Microblink'} src={`${iconsPath}microblink.svg`} />
);

export const IOSAppDownloadIcon: FunctionComponent = () => (
  <img
    alt={'Download on iOS app store icon'}
    src={`${iconsPath}iosAppStore.png`}
  />
);

export const GooglePlayDownloadIcon: FunctionComponent = () => (
  <img
    alt={'Download on google play store icon'}
    src={`${iconsPath}googlePlay.png`}
  />
);

export const ChimeLogo: FunctionComponent = () => (
  <LogoStyling alt="Chime Logo" src={`${iconsPath}headerLogo.svg`} />
);

export const PayAnyonePhone = styled.img.attrs({
  'aria-label': 'Pay Anyone Phone',
  src: `${iconsPath}payAnyonePhone.png`,
})`
  display: block;
  max-height: 263px;
  max-width: 327px;
  width: auto;
  height: auto;
  margin: 0 auto;

  ${media.tinyMobileOnly`
    max-height: 100%;
    max-width: 100%;
  `}
`;

export const DebitCardNumber = styled.img.attrs({
  'aria-label': 'Debit Card Number',
  src: `${iconsPath}debitCardNumber.png`,
})`
  display: block;
  max-width: 278px;
`;

export const CloseIcon: FunctionComponent = () => (
  <CloseStyling alt="Close Modal" src={`${iconsPath}close.svg`} />
);

export const WhiteCloseIcon: FunctionComponent = () => (
  <CloseStyling alt="Close Modal" src={`${iconsPath}white-close.svg`} />
);

export const ErrorIcon: FunctionComponent = () => (
  <ErrorStyling alt="Error Icon" src={`${iconsPath}error.svg`} />
);

export const QuestionCircleIcon: FunctionComponent = () => (
  <QuestionCircleStyling
    alt="Question Circle Icon"
    src={`${iconsPath}questionCircle.svg`}
  />
);

export const CardBackIcon: FunctionComponent = () => (
  <CardBackStyling alt="Card Back Icon" src={`${iconsPath}cardBack.svg`} />
);

export const CardVendorIcon: FunctionComponent<{
  icon: string;
  vendor: string;
}> = ({ icon, vendor }) => {
  const altText = `${vendor} Icon`;
  const imgSrc = `${iconsPath}${icon}.svg`;

  return <CardVendorIconStyling alt={altText} src={imgSrc} />;
};

export const rotate360 = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ButtonSpinnerIcon = styled.img.attrs({
  'aria-label': 'Spinner Icon',
  src: `${iconsPath}loadingSpinner.png`,
})`
  width: 1.5rem;
  height: 1.5rem;
  animation: ${rotate360} 1s steps(8, end) infinite;
`;

export const PartyPopperEmoji = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Party Popper Emoji',
  children: '🎉',
}))`
  margin-right: 0.5rem;
`;

export const WarningIcon = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Warning Emoji',
  children: '⚠️',
}))`
  margin-right: 0.5rem;
`;

export const LightningBoltEmoji = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Lightning Bolt Emoji',
  children: '⚡',
}))``;

export const MoneyFlyEmoji = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Money with Wings Emoji',
  children: '💸',
}))``;

export const LockEmoji = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Lock Emoji',
  children: '🔒',
}))``;

const ValuePropIcon = styled.img`
  width: 100%;
`;

const MoneyBoxStyling = styled.img`
  width: 80px;
`;

const StyledIcon = styled.img`
  display: block;
  margin: 1.5rem auto 0.75rem;
  width: 86px;
  height: auto;
`;

const LogoStyling = styled(StyledIcon)`
  margin: 0;
`;

const CloseStyling = styled(StyledIcon)`
  margin: 0;
  width: 24px;
`;

const ErrorStyling = styled(StyledIcon)`
  margin: 0 0 1.5rem;
  width: 44px;
`;

const QuestionCircleStyling = styled(StyledIcon)`
  margin: 0;
  width: 1rem;
`;

const CardBackStyling = styled(StyledIcon)`
  margin: 0;
  width: auto;
  ${media.tablet`
    margin: 0 8.5rem;
  `}
`;

const CardVendorIconStyling = styled(StyledIcon)`
  margin: 0;
  width: 2.125rem;
  margin-right: 0.5rem;
`;
